// Makes sure we don't show the ultra long path, but rather just the path that's relevant to the user.
// Turns /home/runner/work/sweagentd/sweagentd/src/app/App.tsx into src/app/App.tsx.
// Also handles Windows paths like D:\a\cca-windows-test\cca-windows-test\src\app\App.tsx.

export function trimFileName(path: string): string | undefined {
  try {
    // Handle Windows-style paths (e.g., D:\a\repo-name\repo-name\...)
    // Regex breakdown:
    //   ^[A-Za-z]:    - Drive letter (e.g., D:)
    //   \\a\\         - The GitHub Actions work directory (\a\)
    //   [^\\]+\\      - First occurrence of repo name (e.g., cca-windows-test\)
    //   [^\\]+\\      - Second occurrence of repo name (GitHub Actions duplicates it)
    //   (.*)$         - Capture the remaining relative path
    const windowsMatch = path.match(/^[A-Za-z]:\\a\\[^\\]+\\[^\\]+\\(.*)$/)
    if (windowsMatch && windowsMatch[1] !== undefined) {
      // Convert Windows backslashes to forward slashes for consistency
      const relativePath = windowsMatch[1].replace(/\\/g, '/')
      return relativePath.length > 0 ? relativePath : undefined
    }

    // Handle Unix-style paths (e.g., /home/runner/work/repo-name/repo-name/...)
    const shortenedPath = path.replace('/home/runner/work/', '').split('/').slice(2).join('/')
    return shortenedPath.length > 0 ? shortenedPath : undefined // Special-case the root when viewing the repo, we handle outside
  } catch {
    return path
  }
}
